var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotnessline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 381,
    height: 343,
    viewBox: "0 0 381 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.775 25.1562H204.669L194.553 176.16H184.683L177.775 25.1562Z",
    fill: "url(#paint0_linear_12449_12784)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M177.775 317.787H204.669L194.553 166.783H184.683L177.775 317.787Z",
    fill: "url(#paint1_linear_12449_12784)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M380.47 158.023L380.47 184.918L186.534 174.802L186.534 164.932L380.47 158.023Z",
    fill: "url(#paint2_linear_12449_12784)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.17559e-06 158.023L0 184.918L195.91 174.802L195.91 164.932L1.17559e-06 158.023Z",
    fill: "url(#paint3_linear_12449_12784)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M296.998 329.496L273.706 342.943L185.499 169.932L194.046 164.997L296.998 329.496Z",
    fill: "url(#paint4_linear_12449_12784)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.019 1.01809e-06L72.7278 13.4472L179.444 178.052L187.991 173.117L96.019 1.01809e-06Z",
    fill: "url(#paint5_linear_12449_12784)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M361.707 254.945L348.259 278.237L185.364 172.508L190.299 163.96L361.707 254.945Z",
    fill: "url(#paint6_linear_12449_12784)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4663 64.7109L8.01909 88.0022L182.74 177.196L187.675 168.649L21.4663 64.7109Z",
    fill: "url(#paint7_linear_12449_12784)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M106.763 342.943L83.4719 329.496L189.201 166.601L197.748 171.536L106.763 342.943Z",
    fill: "url(#paint8_linear_12449_12784)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M307.164 13.4492L283.872 0.00199862L194.678 174.723L203.226 179.658L307.164 13.4492Z",
    fill: "url(#paint9_linear_12449_12784)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2102 278.234L18.763 254.943L191.775 166.736L196.709 175.283L32.2102 278.234Z",
    fill: "url(#paint10_linear_12449_12784)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M371.873 88L358.425 64.7087L193.82 171.425L198.755 179.972L371.873 88Z",
    fill: "url(#paint11_linear_12449_12784)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12449_12784",
    x1: 191.222,
    y1: 25.1562,
    x2: 191.222,
    y2: 176.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12449_12784",
    x1: 191.222,
    y1: 317.787,
    x2: 191.222,
    y2: 166.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12449_12784",
    x1: 362.458,
    y1: 171.471,
    x2: 186.534,
    y2: 171.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12449_12784",
    x1: 2.71412,
    y1: 171.471,
    x2: 195.91,
    y2: 171.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12449_12784",
    x1: 276.346,
    y1: 320.621,
    x2: 188.384,
    y2: 168.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12449_12784",
    x1: 85.7305,
    y1: 9.07411,
    x2: 182.328,
    y2: 176.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12449_12784",
    x1: 339.384,
    y1: 257.585,
    x2: 187.029,
    y2: 169.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12449_12784",
    x1: 17.0932,
    y1: 77.7136,
    x2: 184.406,
    y2: 174.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_12449_12784",
    x1: 104.123,
    y1: 320.621,
    x2: 192.086,
    y2: 168.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_12449_12784",
    x1: 294.161,
    y1: 9.0761,
    x2: 197.563,
    y2: 176.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_12449_12784",
    x1: 41.0853,
    y1: 257.583,
    x2: 193.44,
    y2: 169.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_12449_12784",
    x1: 362.798,
    y1: 77.7114,
    x2: 195.486,
    y2: 174.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotnessline);
export default __webpack_public_path__ + "static/media/hotnessline.31c801f64913a434900c4997ab0bae81.svg";
export { ForwardRef as ReactComponent };